import { ButtonHTMLAttributes } from 'react'
import { clsx } from 'clsx'
import styles from './Button.module.scss'

export type ButtonProps = {
    variant?: 'primary' | 'secondary' | 'tertiary' | 'transparent' | 'outline'
    size?: 'xs' | 'small' | 'medium'
    rounded?: boolean
    active?: boolean
} & ButtonHTMLAttributes<HTMLButtonElement>

export const Button = ({
    variant = 'primary',
    size = 'medium',
    rounded = false,
    active,
    children,
    className,
    type = 'button',
    ...props
}: ButtonProps) => {
    return (
        <button
            {...props}
            type={type}
            className={clsx(className, styles.button, styles[variant], styles[size], {
                [styles.active]: active,
                [styles.rounded]: rounded,
            })}
        >
            {children}
        </button>
    )
}
